import useSWR from 'swr'

const useReviewRequest = (requestSlug, contactSlug) => {
  const { data = {}, isLoading } = useSWR(
    `/public/review-request/${requestSlug}`,
    {
      contact: contactSlug,
    }
  )

  return [data, { isLoading }]
}

export default useReviewRequest
